/**
 * MOCK DATA FOR TESTING VIDEO FEATURES
 * 
 * HOW TO USE:
 * 1. Set USE_VIDEO_MOCK_DATA = true to enable mock data in Home.service.ts or VideoListing
 * 2. Choose a test scenario below or create your own
 * 3. Set CURRENT_VIDEO_MOCK_SCENARIO to the scenario you want to test
 * 4. Save the file and the app will use mock data instead of API
 */

// ============================================
// TOGGLE THIS FLAG TO ENABLE/DISABLE MOCKING
// ============================================
import { VideoListRequest } from "@Src/features/Home/services/Home.api.interface";

export const USE_VIDEO_MOCK_DATA = false; // Set to true to use mock data

// ============================================
// TEST SCENARIOS
// ============================================

// Scenario 1: Default video list with 2 items (from user request)
export const SCENARIO_DEFAULT_VIDEOS = {
    success: true,
    StatusMsg: "Video list fetched successfully",
    ResponseType: "SUCCESS",
    data: {
        total_record: 18,
        result_data: [
            {
                VideoId: 1,
                VideoTitle: "Inception - Official Trailer",
                Description: "A thief who steals corporate secrets through dream-sharing technology is given the inverse task of planting an idea.",
                TrailerVideoLink: "https://www.youtube.com/watch?v=YoHD9XEInc0",
                VideoLink: "https://www.youtube.com/watch?v=8hP9D6kZseM"
            },
            {
                VideoId: 2,
                VideoTitle: "Interstellar - Official Trailer",
                Description: "Explorers travel through a wormhole in space to ensure humanity's survival.",
                TrailerVideoLink: "https://www.youtube.com/watch?v=zSWdZVtXT7E",
                VideoLink: "https://www.youtube.com/watch?v=UdHgG1x41g8"
            },
            {
                VideoId: 3,
                VideoTitle: "The Dark Knight - Official Trailer",
                Description: "Batman faces the Joker, a criminal mastermind spreading chaos in Gotham.",
                TrailerVideoLink: "https://www.youtube.com/watch?v=EXeTwQWrcwY",
                VideoLink: "https://www.youtube.com/watch?v=TQfATDZY5Y4"
            },

            // Shemaroo & Free Full Movies
            {
                VideoId: 4,
                VideoTitle: "Sholay - Official Trailer",
                Description: "Two criminals are hired to capture a ruthless bandit.Sholay is a classic Indian action-drama directed by Ramesh Sippy. Former police officer Thakur Baldev Singh hires two small-time criminals, Jai and Veeru, to capture ruthless bandit Gabbar Singh, who terrorizes the village of Ramgarh. As they live among villagers, Jai and Veeru form bonds, especially with Basanti and Radha. Gabbar’s brutality escalates, leading to tragic losses and moral tests. Jai sacrifices himself in the final confrontation, while Veeru defeats Gabbar. The story blends friendship, revenge, love, humor, and sacrifice, ending with justice served and Thakur finally avenging his family and brings peace back to Ramgarh village forever at last.",
                TrailerVideoLink: "https://youtu.be/RDY97iu1_q8?si=cbHmSa5PDOBv2yBR",
                VideoLink: "https://youtu.be/VCK-6rjHmY4?si=misd7Bks2HWfqiCZ"
            }
        ]
    }
};


// Scenario 2: Empty video list
export const SCENARIO_EMPTY_VIDEOS = {
    "success": true,
    "StatusMsg": "No videos found",
    "ResponseType": "SUCCESS",
    "data": {
        "total_record": 0,
        "result_data": []
    }
};

// Scenario 3: Single video item
export const SCENARIO_SINGLE_VIDEO = {
    "success": true,
    "StatusMsg": "Video list fetched successfully",
    "ResponseType": "SUCCESS",
    "data": {
        "total_record": 1,
        "result_data": [
            {
                "VideoId": 1,
                "VideoTitle": "Become GOD of Maths in 3 Months - Target IIT",
                "Description": "I've always struggled to score well in Maths, but then I understood that my approach was wrong. I realised this very very late and I regret it. But this video will make sure that you will not regret not knowing the formula for scoring well in IIT JEE Maths.",
                "VideoLink": "https://www.youtube.com/watch?v=-wzD8Ui8r_s"
            }
        ]
    }
};

// ============================================
// SELECT WHICH SCENARIO TO USE
// ============================================
export const CURRENT_VIDEO_MOCK_SCENARIO = SCENARIO_DEFAULT_VIDEOS;

/**
 * Helper function to get mock video list with pagination support
 * This mimics the API response structure and handles pagination
 */
export const getMockVideoList = (filters?: VideoListRequest) => {
    return new Promise((resolve) => {
        // Simulate API delay
        setTimeout(() => {
            const page = filters?.page || 1;
            const limit = filters?.limit || 10;

            // Get all videos from the current scenario
            const allVideos = CURRENT_VIDEO_MOCK_SCENARIO.data.result_data;
            const totalRecords = allVideos.length;

            // Calculate pagination
            const startIndex = (page - 1) * limit;
            const endIndex = startIndex + limit;
            const paginatedVideos = allVideos.slice(startIndex, endIndex);

            // Return paginated response
            resolve({
                ...CURRENT_VIDEO_MOCK_SCENARIO,
                data: {
                    total_record: totalRecords,
                    result_data: paginatedVideos
                }
            });
        }, 500); // 500ms delay to simulate network
    });
};
